import React from 'react';
import Box from '@mui/material/Box';

export type BallPosition = 'top' | 'bottom';

interface DeploymentBallProps {
  leftPx: number;
  position: BallPosition;
  active: boolean;
  color: string;
  onActivate: () => void;
  onDrag: (clientX: number) => void;
  testId: string;
}

const BASE_SIZE = 14;
const ACTIVE_SIZE = 18;

const DeploymentBall: React.FC<DeploymentBallProps> = ({
  leftPx,
  position,
  active,
  color,
  onActivate,
  onDrag,
  testId,
}) => {
  const handlePointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.currentTarget.setPointerCapture(event.pointerId);
    onActivate();
  };

  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    if (event.buttons === 0) return;
    onDrag(event.clientX);
  };

  const handlePointerUp = (event: React.PointerEvent<HTMLDivElement>) => {
    event.currentTarget.releasePointerCapture(event.pointerId);
  };

  const size = active ? ACTIVE_SIZE : BASE_SIZE;

  return (
    <Box
      data-testid={testId}
      role="slider"
      aria-valuenow={0}
      tabIndex={0}
      sx={(theme) => ({
        position: 'absolute',
        left: leftPx,
        [position === 'top' ? 'top' : 'bottom']: -(size / 2),
        width: size,
        height: size,
        borderRadius: '50%',
        cursor: 'ew-resize',
        transform: 'translateX(-50%)',
        backgroundColor: color,
        border: `2px solid ${theme.palette.background.paper}`,
        boxShadow: active
          ? `0 0 0 3px ${color}55, 0 2px 6px rgba(0,0,0,0.28)`
          : '0 1px 3px rgba(0,0,0,0.28)',
        transition: 'width 120ms ease, height 120ms ease, box-shadow 120ms ease',
        touchAction: 'none',
        zIndex: active ? 3 : 2,
      })}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
    />
  );
};

export default DeploymentBall;
